import React, { Fragment, memo } from 'react';
import { CURRENCY_USD } from 'constants/currency';
import { EMPTY_COACH_AVATAR_SRC } from 'constants/user';
import { getProfileImageUrlOrPlaceholder } from 'utils/shared/user/getProfileImageUrlOrPlaceholder';
import CloseIcon from 'svg/CloseIcon';
import CoachBadge from 'svg/CoachBadge';
import { ButtonText } from 'components/Button';
import CardCoach from 'components/cards/CardCoach';
import classNames from 'styles/utils/classNames';
import { LessonMapMarkerProps } from './props';
import { isCoachProfile } from './utils';

const MemoizedCoachBadge = memo(CoachBadge);
const MemoizedCardCoach = memo(CardCoach);

const LessonMapMarker: React.FC<LessonMapMarkerProps> = ({
  listHoveredCoachId,
  setListHoveredCoachId,
  setActiveCoachId,
  activeCoach,
  coach,
}) => {
  return (
    <Fragment>
      <div
        onClick={() => setActiveCoachId(coach.id)}
        onMouseLeave={() => setListHoveredCoachId(null)}
        onMouseEnter={() => setListHoveredCoachId(coach.id)}
        className={classNames(
          'group relative flex h-8 w-8 cursor-pointer items-center justify-center rounded-full shadow-[0px_4px_4px_0px_rgba(0,0,0,0.16)]',
          listHoveredCoachId === coach.id
            ? 'z-20 bg-color-bg-lightmode-brand text-color-text-lightmode-invert dark:bg-color-bg-lightmode-brand dark:text-color-text-lightmode-invert'
            : 'bg-color-bg-lightmode-primary text-color-text-lightmode-secondary dark:bg-color-bg-darkmode-primary dark:text-color-text-darkmode-secondary',
        )}
      >
        <MemoizedCoachBadge className="h-4 w-4" />
      </div>
      {activeCoach && activeCoach.id === coach.id && (
        <div className="absolute left-7 top-1/2 isolate z-60 ml-4  flex w-[20rem] -translate-y-1/2 transform justify-center rounded-t-xl bg-color-bg-lightmode-primary p-ds-lg dark:bg-color-bg-darkmode-primary">
          <div className="absolute right-6 top-6 z-10 flex items-center justify-center rounded-full bg-color-bg-lightmode-invert bg-opacity-50">
            <ButtonText
              onClick={() => {
                setActiveCoachId(null);
              }}
              className="flex items-center justify-center rounded-full p-2"
            >
              <CloseIcon className="h-6 w-6 text-color-text-lightmode-invert" />
            </ButtonText>
          </div>
          <MemoizedCardCoach
            key={activeCoach.id}
            id={activeCoach.id}
            slug={isCoachProfile(activeCoach) ? activeCoach.username : activeCoach.id}
            photoUrl={
              isCoachProfile(activeCoach)
                ? getProfileImageUrlOrPlaceholder({
                    path: activeCoach.profileImagePath || '',
                    placeholder: EMPTY_COACH_AVATAR_SRC,
                  })
                : activeCoach.profileImageUrl ||
                  activeCoach.aboutPhotoImageUrl ||
                  activeCoach.logoImageUrl ||
                  EMPTY_COACH_AVATAR_SRC
            }
            certificationImages={[]}
            fullName={
              isCoachProfile(activeCoach) ? activeCoach.fullName || '' : activeCoach.name || ''
            }
            price={isCoachProfile(activeCoach) ? activeCoach.priceUnitAmountCoachDefault || 0 : 0}
            distance={activeCoach.distance}
            currency={
              isCoachProfile(activeCoach)
                ? activeCoach.stripeMerchantCurrency ||
                  activeCoach.currencyCoachDefault ||
                  CURRENCY_USD
                : CURRENCY_USD
            }
          />
        </div>
      )}
    </Fragment>
  );
};

export default LessonMapMarker;
